module.exports = __webpack_public_path__ + "static/media/ibm.72898f09.jpg";